import { Fragment, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import SEO from "../../components/seo";
import { getDiscountPrice } from "../../helpers/product";
import LayoutOne from "../../layouts/LayoutOne";
import Breadcrumb from "../../wrappers/breadcrumb/Breadcrumb";
import { addToCart, decreaseQuantity, deleteFromCart, increaseQuantity, deleteAllFromCart } from "../../store/slices/cart-slice";
import { cartItemStock } from "../../helpers/product";
import { updateCartElement } from "../../store/slices/cart-slice";

import calcularDigitoVerificador from "../../helpers/rut";
import { Dropdown, DropdownButton, Modal, Spinner } from "react-bootstrap";
import { format } from 'react-rut';
import ModalPaciente from "./ModalPaciente";
import { getDescuentoPaciente } from "../../firebase/firebase-functions";
import { connectStorageEmulator } from "firebase/storage";
import { validaSeguroPaciente } from "../../helpers/validators";


const Cart = () => {
  let cartTotalPrice = 0;


  const { arrPacientes } = useSelector((state) => state.paciente);

  const [quantityCount] = useState(1);
  const dispatch = useDispatch();
  let { pathname } = useLocation();

  const currency = useSelector((state) => state.currency);
  const { cartItems } = useSelector((state) => state.cart);
  const { modalidadSeleccionada } = useSelector((state) => state.modalidad)
  const [requiereReceta, setRequiereReceta] = useState(false);
  const cantidadMaximaAComprar = 5;

  const [loadingPrecioFinal, setLoadingPrecioFinal] = useState(false)
  // const modificaPaciente_old = async (paciente, cartItem, index) => {
  //   setLoadingPrecioFinal(true)
  //   //console.log("paciente seleccionado")
  //   //console.log(paciente)
  //   //console.log(cartItem)
  //   let objCarro = { ...cartItem }
  //   let obj = {
  //     rutp: paciente.rut.padStart(8, "0"),
  //     kinf: cartItem.medicamento.kinf,
  //     trec: 'RCC',
  //     pres: cartItem.medicamento.pres,
  //     ksuc: modalidadSeleccionada.codigo,
  //   }
  //   await getDescuentoPaciente(obj).then((res) => {
  //     //console.log("res")
  //     //console.log(res)
  //     objCarro.precioFinal = Math.floor(cartItem.medicamento.precio - (res.descuentoPac / 100) * cartItem.medicamento.precio)
  //     objCarro.porc_descuento = res.descuentoPac
  //   })
  //     .catch((error) => {
  //       //console.log(error)
  //     })
  //     .finally(() => {
  //       dispatch(
  //         updateCartElement({ ...objCarro, rut: paciente.rut, pac_nombre: paciente.nombre, pac_apellidos: paciente.apellidos, index: index }))
  //     })
  //   setLoadingPrecioFinal(false)


  // }


  
  const modificaPaciente = async (paciente, cartItem, index) => {
    setLoadingPrecioFinal(true)
    console.log("paciente seleccionado")
    console.log(paciente)
    console.log(cartItem)
    let objCarro = { ...cartItem }

    //revisar si utiliza seguro, si utiliza seguro debo revisar si el paciente tiene seguro, si no tiene, se debe cambiar a utilizaSeguro false

    if(objCarro.utilizaSeguro){
        const puedeUtilizarSeguro = await validaSeguroPaciente(paciente.rut, cartItem.medicamento.kinf)

        console.log(puedeUtilizarSeguro);

        if (!puedeUtilizarSeguro) {
            let obj = {
                rutp: paciente.rut.padStart(8, "0"),
                kinf: cartItem.medicamento.kinf,
                trec: 'RCC',
                pres: cartItem.medicamento.pres,
                ksuc: modalidadSeleccionada.codigo,
            }
            await getDescuentoPaciente(obj).then((res) => {
                //console.log("res")
                //console.log(res)
                objCarro.precioFinal = Math.floor(cartItem.medicamento.precio - (res.descuentoPac / 100) * cartItem.medicamento.precio)
                objCarro.porc_descuento = res.descuentoPac
                
            })
                .catch((error) => {
                    //console.log(error)
                })
                .finally(() => {
                    dispatch(
                        updateCartElement({ ...objCarro, rut: paciente.rut, pac_nombre: paciente.nombre, pac_apellidos: paciente.apellidos, index: index }))
                })
        }
        else {
            
            dispatch(
                updateCartElement({ ...objCarro, rut: paciente.rut, pac_nombre: paciente.nombre, pac_apellidos: paciente.apellidos, index: index }))   
        }
    }
    else {
        let obj = {
            rutp: paciente.rut.padStart(8, "0"),
            kinf: cartItem.medicamento.kinf,
            trec: 'RCC',
            pres: cartItem.medicamento.pres,
            ksuc: modalidadSeleccionada.codigo,
        }
        await getDescuentoPaciente(obj).then((res) => {
            //console.log("res")
            //console.log(res)
            objCarro.precioFinal = Math.floor(cartItem.medicamento.precio - (res.descuentoPac / 100) * cartItem.medicamento.precio)
            objCarro.porc_descuento = res.descuentoPac
            objCarro.utilizaSeguro = false
            
        })
            .catch((error) => {
                //console.log(error)
            })
            .finally(() => {
                dispatch(
                    updateCartElement({ ...objCarro, rut: paciente.rut, pac_nombre: paciente.nombre, pac_apellidos: paciente.apellidos, index: index }))
            })
    }



    setLoadingPrecioFinal(false)


}

  //nuevo paciente
  const [nuevoPacienteVisible, setNuevoPacienteVisible] = useState(false)

  useEffect(() => {
    //console.log(cartItems)
    setRequiereReceta(false)
    //revisa si alguno de los medicamentos en el carro requiere receta
    cartItems.forEach(element => {
      if (element.medicamento.tipo_venta === "Receta Medica" || element.medicamento.tipo_venta === "Receta Medica Retenida") {
        //console.log("requiere receta " + element.medicamento.nombre)
        return setRequiereReceta(true)
      }

    });
    //console.log(modalidadSeleccionada)

    return () => {
      //console.log("cleaned up");
    };
  }, [cartItems])


  return (
    <Fragment>
      <SEO
        titleTemplate="Carrito"
        description="Cart Venta Online 2.0 - Liga Chilena contra la Epilepsia."
      />

      <LayoutOne headerTop="visible">
        {/* breadcrumb */}
        <Breadcrumb
          pages={[
            { label: "Home", path: process.env.PUBLIC_URL + "/" },
            { label: "Carrito", path: process.env.PUBLIC_URL + pathname }
          ]}
        />
        <div className="cart-main-area pt-90 pb-100">
          <div className="container">
            <Modal show={loadingPrecioFinal}

              size="sm"

              backdropClassName="text-center"
              contentClassName="bg-transparent text-center border-0 align-items-center justify-content-center"

            ><Spinner animation="border" variant="light" className="text-center" role="status" /></Modal>
            <ModalPaciente showPacienteModal={nuevoPacienteVisible} onHidePacienteModal={() => setNuevoPacienteVisible(false)} />
            {cartItems && cartItems.length >= 1 ? (
              <Fragment>
                <h3 className="cart-page-title">Tus medicamentos en el carro</h3>
                <div className="row">
                  <div className="col-12">
                    <div className="table-content table-responsive cart-table-content">
                      <table>
                        <thead>
                          <tr>
                            <th>Imagen</th>
                            <th>Nombre del medicamento</th>
                            <th>Precio unitario</th>
                            <th>Cantidad</th>
                            <th>Subtotal</th>
                            <th>Acción</th>
                          </tr>
                        </thead>
                        <tbody>
                          {cartItems.map((cartItem, index) => {


                            let arrSinPacienteCarro = arrPacientes.filter(paciente => paciente.rut !== cartItem.rut)



                            return (
                              <tr key={index}>
                                <td className="product-thumbnail">
                                  <Link
                                    to={
                                      process.env.PUBLIC_URL +
                                      "/product/" +
                                      cartItem.id
                                    }
                                  >
                                    <img
                                      className="img-fluid"
                                      src={
                                        process.env.PUBLIC_URL +
                                        cartItem.medicamento.image[0]
                                      }
                                      alt=""
                                    />
                                  </Link>
                                </td>

                                <td className="product-name dropdown-custom">
                                  <Link
                                    to={
                                      process.env.PUBLIC_URL +
                                      "/product/" +
                                      cartItem.id
                                    }
                                  >
                                    {cartItem.nombre}
                                    <p style={{ fontSize: 14, paddingBottom: 0, marginBottom: 1 }}>
                                      {"(" + cartItem.medicamento.contenido + ") "}
                                    </p>
                                  </Link>

                                  <p className="mb-0" style={{ fontSize: 16 }}>
                                    {"Asociado a paciente: "}
                                  </p>
                                  {/* <p>
                                    {"Rut: "}<span>{format(cartItem.rut + calcularDigitoVerificador(cartItem.rut))}</span>
                                  </p> */}
                                  <DropdownButton title={cartItem.pac_nombre !== 'undefined undefined' ? format(cartItem.rut + (calcularDigitoVerificador(cartItem.rut)==='11' ? 0 : calcularDigitoVerificador(cartItem.rut))) + " / " + cartItem.pac_nombre + " " + cartItem.pac_apellidos : "Seleccione paciente"} className="mt-2 dropdown-custom">

                                    {
                                      arrSinPacienteCarro.map((paciente, indexPac) => (
                                        <Dropdown.Item
                                          onClick={() => modificaPaciente(paciente, cartItem, index)}
                                        >
                                          {format(paciente.rut + (calcularDigitoVerificador(paciente.rut)==='11' ? 0 : calcularDigitoVerificador(paciente.rut))) + " / " + paciente.nombre + " " + paciente.apellidos}
                                        </Dropdown.Item>
                                      ))
                                    }
                                    <Dropdown.Item
                                      onClick={() => {
                                        //console.log("nuevo paciente")
                                        setNuevoPacienteVisible(true)
                                      }}
                                    >
                                      {"Agregar un nuevo paciente"}
                                    </Dropdown.Item>
                                  </DropdownButton>

                                </td>

                                <td className="product-price-cart">


                                  {cartItem.precio === cartItem.precioFinal ? "$" + cartItem.precioFinal.toLocaleString("es-CL")
                                    :
                                    <div>
                                      <p><span className="precio-anterior">${cartItem.precio.toLocaleString("es-CL")}</span> <span className="precio-final">$ {cartItem.precioFinal.toLocaleString("es-CL")}</span></p>

                                    </div>

                                  }



                                </td>

                                <td className="product-quantity">
                                  <div className="cart-plus-minus">
                                    <button
                                      className="dec qtybutton"
                                      onClick={() =>
                                        dispatch(decreaseQuantity(cartItem))
                                      }
                                    >
                                      -
                                    </button>
                                    <input
                                      className="cart-plus-minus-box"
                                      type="text"
                                      value={cartItem.cantidad}
                                      readOnly
                                    />
                                    <button
                                      className="inc qtybutton"
                                      onClick={() => {
                                        //console.log(cartItem)
                                        //console.log(cartItem.medicamento.stock)
                                        let medicamentosEnCarro = cartItems.filter(item => item.id === cartItem.id)
                                        let cantidadEnCarro = 0
                                        medicamentosEnCarro.map(item => cantidadEnCarro += item.cantidad)
                                        //console.log("en carro "+cantidadEnCarro)
                                        if (cartItem.cantidad < cantidadMaximaAComprar && cantidadEnCarro < cartItem.medicamento.stock) {
                                          dispatch(increaseQuantity(cartItem))
                                        }
                                      }
                                      }

                                    >
                                      +
                                    </button>
                                  </div>
                                  {
                                    cartItem.medicamento.pap_maestro && Number.parseInt((cartItem.cantidad * cartItem.medicamento.pres) / cartItem.medicamento.pap.requerido) >0 ?
                                      <p style={{lineHeight: "20px"}} id="bonificacion-seleccion">{"Recibirás " + Number.parseInt((cartItem.cantidad * cartItem.medicamento.pres) / cartItem.medicamento.pap.requerido) + " caja(s) adicional sin costo"}</p>
                                      : null}
                                </td>
                                <td className="product-subtotal">
                                  {/* {"$" + (cartItem.cantidad * cartItem.precioFinal).toLocaleString("es-CL")} */}


                                  {cartItem.precio === cartItem.precioFinal ? "$" + (cartItem.precio * cartItem.cantidad).toLocaleString("es-CL")
                                    :
                                    <div>
                                      <p><span className="precio-anterior">{"$" + (cartItem.precio * cartItem.cantidad).toLocaleString("es-CL")}</span> <span className="precio-final">{" $" + (cartItem.precioFinal * cartItem.cantidad).toLocaleString("es-CL")}</span></p>

                                    </div>

                                  }


                                  {/* {discountedPrice !== null
                                    ? currency.currencySymbol +
                                      (
                                        finalDiscountedPrice * cartItem.quantity
                                      ).toFixed(2)
                                    : currency.currencySymbol +
                                      (
                                        finalProductPrice * cartItem.quantity
                                      ).toFixed(2)} */}
                                </td>

                                <td className="product-remove">
                                  <button
                                    onClick={() =>
                                      dispatch(deleteFromCart(cartItem))
                                    }
                                  >
                                    <i style={{fontSize: "25px"}} className="fa fa-trash"></i>
                                  </button>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-12">
                    <div className="cart-shiping-update-wrapper">
                      <div className="cart-clear ">
                        <button onClick={() => dispatch(deleteAllFromCart())}
                          className=" btn-1">
                          Limpiar carro
                        </button>
                      </div>
                      <div className="cart-clear">
                        <Link
                          className=" btn-1"
                          to={process.env.PUBLIC_URL + "/medicamentos"}
                        >
                          Continuar comprando
                        </Link>
                      </div>
                      <div className="">
                        {
                          requiereReceta ?
                            <Link
                              to={process.env.PUBLIC_URL + "/recetas"}
                              className="btn-2"
                            >
                              Ir a recetas
                            </Link>

                            :

                            <Link
                              to={process.env.PUBLIC_URL + "/despacho"}
                              className="btn-2"
                            >
                              {modalidadSeleccionada.tipo === "retiro" ? "Ir a Retiro" : "Ir a Despacho"}

                            </Link>
                        }

                      </div>

                    </div>
                  </div>
                </div>

                {/* <div className="row">
                  <div className="col-lg-4 col-md-6">
                    <div className="cart-tax">
                      <div className="title-wrap">
                        <h4 className="cart-bottom-title section-bg-gray">
                          Estimate Shipping And Tax
                        </h4>
                      </div>
                      <div className="tax-wrapper">
                        <p>
                          Enter your destination to get a shipping estimate.
                        </p>
                        <div className="tax-select-wrapper">
                          <div className="tax-select">
                            <label>* Country</label>
                            <select className="email s-email s-wid">
                              <option>Bangladesh</option>
                              <option>Albania</option>
                              <option>Åland Islands</option>
                              <option>Afghanistan</option>
                              <option>Belgium</option>
                            </select>
                          </div>
                          <div className="tax-select">
                            <label>* Region / State</label>
                            <select className="email s-email s-wid">
                              <option>Bangladesh</option>
                              <option>Albania</option>
                              <option>Åland Islands</option>
                              <option>Afghanistan</option>
                              <option>Belgium</option>
                            </select>
                          </div>
                          <div className="tax-select">
                            <label>* Zip/Postal Code</label>
                            <input type="text" />
                          </div>
                          <button className="cart-btn-2" type="submit">
                            Get A Quote
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6">
                    <div className="discount-code-wrapper">
                      <div className="title-wrap">
                        <h4 className="cart-bottom-title section-bg-gray">
                          Use Coupon Code
                        </h4>
                      </div>
                      <div className="discount-code">
                        <p>Enter your coupon code if you have one.</p>
                        <form>
                          <input type="text" required name="name" />
                          <button className="cart-btn-2" type="submit">
                            Apply Coupon
                          </button>
                        </form>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-12">
                    <div className="grand-totall">
                      <div className="title-wrap">
                        <h4 className="cart-bottom-title section-bg-gary-cart">
                          Cart Total
                        </h4>
                      </div>
                      <h5>
                        Total products{" "}
                        <span>
                          {currency.currencySymbol + cartTotalPrice.toFixed(2)}
                        </span>
                      </h5>

                      <h4 className="grand-totall-title">
                        Grand Total{" "}
                        <span>
                          {currency.currencySymbol + cartTotalPrice.toFixed(2)}
                        </span>
                      </h4>
                      <Link to={process.env.PUBLIC_URL + "/checkout"}>
                        Proceed to Checkout
                      </Link>
                    </div>
                  </div>
                </div> */}
              </Fragment>
            ) : (
              <div className="row">
                <div className="col-lg-12">
                  <div className="item-empty-area text-center">
                    <div className="item-empty-area__icon mb-30">
                      <i className="pe-7s-cart"></i>
                    </div>
                    <div className="item-empty-area__text">
                      Sin medicamentos en el carro <br />{" "}
                      <Link to={process.env.PUBLIC_URL + "/medicamentos"} className="boton">
                        Comprar ahora
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </LayoutOne>
    </Fragment>
  );
};

export default Cart;
